<template>
  <div class="message">
    <div class="message_list" v-if="messageList.length > 0">
        <div
            class="message_list_item"
            v-for="(item, index) in messageList"
            :key="index"
            @click="detail(item)"
        >
            <span :title="item.article.title">{{ item.article.title }}</span>
            <!-- <span>{{ formatTime(item.modify_at) }}</span> -->
        </div>
    </div>
  </div>
</template>
<script>
import { getMessageList } from "@/api/message";
export default {
  data() {
    return {
      messageList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await getMessageList({
        limit: 10,
      });
      this.messageList = res.data.results;
    },
    detail(item) {
      window.open(`/messageDetail?id=${item.id}`, "_blank");
    },
    formatTime(time) {
        const date = new Date(time);
        let month = date.getMonth() + 1;
        let day = date.getDate();
        if (month < 10) {
            month = "0" + month;
        }
        if (day < 10) {
            day = "0" + day;
        }
        return `${month}/${day}`;
    }
  },
};
</script>
<style lang="scss" scoped>
.message {
    width: 310px;
    height: 310px;
    overflow-y: scroll;
    .message_list {
        width: 100%;
        .message_list_item {
            padding: 3px 10px;
            font-size: 18px;
            margin: 0 10px;
            cursor: pointer;
            text-align: left;
            border-bottom: #333 1px solid;
            &:hover {
                color: #c0dbfb;
            }
            span {
                &:first-child {
                    width: 200px;
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                // &:last-child {
                //     float: right;
                // }
            }
            &:last-child {
                border-bottom: none;
            }
        }
    }
}
.message::-webkit-scrollbar {
    width: 8px;
}
.message::-webkit-scrollbar-track {
    background-color:#fff;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius:2em;
}
.message::-webkit-scrollbar-thumb {
    background-color:#c0dbfb;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius:2em;
}
</style>
